<template>
  <div v-loading="isLoading" style="display: flex; flex-direction: row; justify-content: center; height: 100%; width: 100%; align-items: stretch">
    <!-- 外层容器：全屏居中 + 科技感背景 -->
    <div style="position: relative" class="topic-assistant-container" :class="{ big_chat_box: showWorkBench === false, small_chat_box: showWorkBench === true }">
      <!-- 核心卡片：固定800px + 科技风边框 -->
      <div class="core-card">
        <!-- 问候语组件 -->
        <!-- <GreetingLabel :greetingMsg="greetingMsg" :curInfoToolTipMsg="curInfoToolTipMsg"/> -->
        <GreetingLabel ref="childRefGreetingLabel" />

        <!-- 表单区域：网格化布局 + 清晰层级 -->
        <el-form ref="topicForm" :model="form" :rules="formRules" class="topic-form">
          <!-- 个人研究兴趣（必填） -->
          <el-form-item label="研究兴趣" prop="researchInterest" class="form-item">
            <el-input v-model="form.researchInterest" type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="请输入具体研究领域/细分方向，例如：深度学习在自然语言处理中的情感分析应用、区块链技术在供应链金融中的风险控制研究..." class="form-control"></el-input>
            <div class="form-hint"><i class="el-icon-info"></i> 必填项，描述越具体，选题匹配度越高（至少10个字符）</div>
          </el-form-item>

          <!-- 导师研究方向（选填） -->
          <el-form-item label="导师研究方向" prop="tutorDirection" class="form-item">
            <el-input v-model="form.tutorDirection" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="选填：补充导师专长领域/研究方法，例如：导师长期研究机器学习算法优化，聚焦小样本数据处理与模型泛化性提升..." class="form-control"></el-input>
            <div class="form-hint optional-hint"><i class="el-icon-star-off"></i> 选填项，补充后可提升选题与团队研究的契合度</div>
          </el-form-item>

          <!-- 提交按钮：居中 + 科技感样式 -->
          <el-form-item class="submit-item">
            <el-button type="primary" @click="toGenerate(form.researchInterest, form.tutorDirection, false)" :loading="isLoading" class="generate-btn">
              <i class="el-icon-rocket"></i>
              生成选题方案
            </el-button>
          </el-form-item>
        </el-form>

        <el-row class="tool_intro_box" v-show="assistance_case_list.length > 0">
          <div style="margin: 10px; font-size: 13px; color: var(--txt-color3) !important">选题示例</div>
          <!-- <template v-for="assistance_case,idx in assistance_case_list">
            <el-button :key="idx" style="margin: 5px; text-align: left; line-height: 20px;" icon="" round @click="toGenerate(assistance_case['user_interest'], assistance_case['teacher_direction'], true)" v-safe-html="'研究兴趣：'+assistance_case['user_interest']+'<br>导师方向：'+assistance_case['teacher_direction']"></el-button>
          </template> -->

          <div class="assistance-case-container">
            <!-- 循环渲染案例按钮 -->
            <el-button v-for="(assistance_case, idx) in assistance_case_list" :key="idx" class="assistance-case-btn" icon="" round @click="toGenerate(assistance_case.user_interest, assistance_case.teacher_direction, true)">
              <!-- 替换v-safe-html为模板内容，更安全且易维护 -->
              <div class="case-content">
                <div class="case-item">
                  <span class="case-label">研究兴趣：</span>
                  <span class="case-value">{{ assistance_case.user_interest }}</span>
                </div>
                <div class="case-item">
                  <span class="case-label">导师方向：</span>
                  <span class="case-value">{{ assistance_case.teacher_direction }}</span>
                </div>
              </div>
            </el-button>
          </div>
        </el-row>
      </div>
    </div>

    <!-- 工作台 -->
    <div v-if="showWorkBench" class="my_workbench">
      <TopicAssistantResultWorkBench :content="workbench_content" style="width: 100%; height: 100%" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import GreetingLabel from "./GreetingLabel.vue";
// import WorkBench from '../components/WorkBench.vue';
import TopicAssistantResultWorkBench from "../components/TopicAssistantResultWorkBench.vue";
export default {
  name: "TopicAssistant",
  components: {
    GreetingLabel,
    // WorkBench,
    TopicAssistantResultWorkBench,
  },
  props: {
    greetingMsg: {},
    curInfoToolTipMsg: {
      type: String,
    },
    dataContent: {
      type: Array,
    },
    conversationId: {
      type: [String, Number],
      default: null,
    },
    toolIdx: {
      type: Number,
      default: null,
    },
    toolList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        researchInterest: "",
        tutorDirection: "",
      },
      formRules: {
        researchInterest: [
          { required: true, message: "请输入研究兴趣", trigger: "blur" },
          { min: 10, message: "研究兴趣描述至少10个字符", trigger: "blur" },
        ],
      },
      isLoading: false,
      showWorkBench: false,
      workbench_type: "topic_selection_assistance",
      workbench_content: null,
      assistance_case_list: [],
    };
  },
  mounted() {
    // 渲染功能10字简介
    this.$refs.childRefGreetingLabel.render_greeting_msg(this.greetingMsg, this.curInfoToolTipMsg);
    this.restoreCachedForm();

    // 请求小栗子
    this.select_topic_assistance_case();
  },
  watch: {
    // 发送按钮高亮/置灰控制
    dataContent(newVal, oldVal) {
      // 有传入的数据就渲染数据
      if (newVal != null) {
        this.workbench_content = this.dataContent;
        this.showWorkBench = true;
      }
    },
  },
  methods: {
    restoreCachedForm() {
      const savedForm = sessionStorage.getItem("topic_assistant_form");
      if (!savedForm) return;

      try {
        const { researchInterest = "", tutorDirection = "" } = JSON.parse(savedForm);
        this.form.researchInterest = researchInterest;
        this.form.tutorDirection = tutorDirection;
      } catch (error) {
        sessionStorage.removeItem("topic_assistant_form");
      }
    },
    cacheTopicAssistantContext(researchInterest, tutorDirection) {
      sessionStorage.setItem(
        "topic_assistant_form",
        JSON.stringify({
          researchInterest,
          tutorDirection,
        }),
      );

      sessionStorage.setItem(
        "topic_assistant_back_context",
        JSON.stringify({
          conversation_id: this.conversationId,
          tool_idx: this.toolIdx,
          tool_list: this.toolList,
        }),
      );
    // 请求小栗子
    },
    select_topic_assistance_case() {
      this.$http.get(this.globalUrl.select_topic_assistance_case).then(res => {
        this.assistance_case_list = res.data;
      });
    },

    // 关闭工作台
    clossWorkBench() {
      this.showWorkBench = false;
    },
    generation_func(researchInterest, tutorDirection, is_create_task) {
      this.isLoading = true;
      this.showWorkBench = false;
      this.workbench_content = null;
      this.$message({
        message: "选题方案生成中，请稍后...",
        type: "success",
        duration: 1500,
        center: true,
      });

      this.$http
        .post(this.globalUrl.topic_assistance, { user_interest: researchInterest, teacher_direction: tutorDirection, is_create_task: is_create_task })
        .then(res => {
          // 保存选题结果到本地存储
          this.cacheTopicAssistantContext(researchInterest, tutorDirection);
          sessionStorage.setItem("topic_assistant_result", JSON.stringify(res.data));
          // 跳转到新的选题结果页面
          this.$router.push({
            name: "topic_assistant_result",
          });
        })
        .finally(() => {
          // 无论成功/失败，最终都会执行这里
          this.isLoading = false;
        });
    },
    toGenerate(researchInterest, tutorDirection, is_case) {
      if (is_case) this.generation_func(researchInterest, tutorDirection, false); // 命中了示例的回答本身也不会创建任务，所以这里传false还是true都行
      else {
        this.$refs.topicForm.validate(isValid => {
          if (isValid) {
            this.generation_func(researchInterest, tutorDirection, true);
          } else {
            this.$message({
              message: "请完善研究兴趣信息（至少10个字符）",
              type: "error",
              duration: 1500,
              center: true,
            });
          }
        });
      }
    },
  },
};
</script>

<!-- 适配全局样式变量的科技风样式 + 固定800px不变形 -->
<style scoped>
/* 核心固定尺寸变量 */
:root {
  --fixed-width: 800px; /* 核心固定宽度 */
  --form-label-width: 110px; /* 表单标签宽度 */
  --radius-sm: 8px; /* 小圆角 */
  --radius-md: 12px; /* 中圆角 */
  --transition: all 0.3s ease; /* 过渡动画 */
}

/* 外层容器：全屏居中 + 适配全局背景 */
.topic-assistant-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: background-color 0.3s ease;
}

/* 核心卡片：固定800px + 适配全局卡片样式 */
.core-card {
  margin: 0 20px;
  width: var(--fixed-width);
  max-width: 100%;
  /* padding: 45px 0; */
  box-sizing: border-box;
  position: relative;
  overflow-y: auto;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

/* 表单样式：清晰层级 + 网格化 */
.topic-form {
  width: 100%;
}

.form-item {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

/* 表单标签：左对齐 + 适配全局文字颜色 */
.el-form-item__label {
  width: var(--form-label-width) !important;
  font-size: var(--font-size);
  color: var(--txt-color);
  font-weight: 500;
  padding: 0 0 10px 0 !important;
  text-align: left !important;
}

/* 表单控件容器：自适应宽度 */
.el-form-item__content {
  flex: 1;
  width: calc(100% - var(--form-label-width)) !important;
}

/* 自定义表单控件：输入框/文本域 */
.form-control {
  width: 100%;
  border: none;
  border-radius: var(--radius-sm);
  transition: var(--transition);
  box-sizing: border-box;
}

.form-control::v-deep .el-textarea__inner {
  padding: 16px 18px;
  font-size: var(--font-size);
  color: var(--txt-color);
  border: 1px solid var(--btn-border);
  border-radius: var(--radius-sm);
  line-height: var(--line-height-base);
  resize: none;
  background-color: var(--bg-front);
  transition: color 0.3s ease;
  border-radius: 20px !important;
}

/* 隐藏 Webkit 内核浏览器（Chrome、Safari、Edge）的滚动条 */
.form-control::v-deep .el-textarea__inner::-webkit-scrollbar {
  display: none; /* 直接隐藏滚动条 */
}

/* 隐藏 Firefox 浏览器的滚动条 */
.form-control::v-deep .el-textarea__inner {
  scrollbar-width: none; /* Firefox 专属属性，隐藏滚动条 */
}

/* 隐藏 IE/旧版 Edge 浏览器的滚动条（兼容性补充） */
.form-control::v-deep .el-textarea__inner {
  -ms-overflow-style: none; /* IE/Edge 专属属性 */
}

/* 输入框聚焦效果：适配全局主色 + 轻微发光 */
.form-control:focus-within {
  border-color: var(--blue);
  /* box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1); */
  outline: none;
}

/* 表单提示文本：小字号 + 适配全局文字颜色 */
.form-hint {
  font-size: 13px;
  color: var(--txt-color2);
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.3s ease;
}

.form-hint i {
  font-size: 13px;
  color: var(--blue);
}

.optional-hint {
  color: var(--txt-color3);
}

/* 提交按钮区域：居中 */
.submit-item {
  margin-top: 15px;
  text-align: center;
}

/* 生成按钮：调整为柔和色调，适配全局变量，降低亮度 */
.generate-btn {
  /* 使用全局柔和蓝色，降低背景色饱和度 */
  background-color: var(--btn-bg-hover2) !important;
  /* border: 1px solid var(--blue) !important; */
  border-radius: 20px !important;
  padding: 12px 50px !important;
  font-size: var(--font-size);
  font-weight: 500;
  color: #ffffff !important;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  /* 增加轻微透明，降低亮度 */
  opacity: 0.95;
  /* 柔和阴影代替高亮 */
  box-shadow: 0 2px 8px rgba(6, 64, 126, 0.2) !important;
}

.generate-btn:hover {
  /* 夜间模式用深蓝，白天模式用稍深的蓝 */
  background-color: var(--btn-bg-hover2) !important;
  border-color: var(--btn-bg-hover2) !important;
  transform: translateY(-2px);
  /* 弱化hover阴影，减少刺眼感 */
  box-shadow: 0 4px 12px rgba(6, 64, 126, 0.25) !important;
  opacity: 1;
}

.generate-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(6, 64, 126, 0.2) !important;
}

.generate-btn.is-loading {
  /* loading状态更柔和的透明度 */
  background-color: var(--btn-bg-hover2) !important;
  border-color: var(--blue) !important;
  opacity: 0.85 !important;
  transform: none !important;
  box-shadow: 0 2px 8px rgba(6, 64, 126, 0.2) !important;
}

/* 响应式：500-800px区间强制固定800px，不变形 */
@media (min-width: 500px) and (max-width: 800px) {
  .topic-assistant-container {
    padding: 30px 0;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .topic-assistant-container::-webkit-scrollbar {
    display: none;
  }
  .core-card {
    width: var(--fixed-width); /* 强制固定800px */
  }
}

/* 小于500px兼容：自适应布局 */
@media (max-width: 500px) {
  .core-card {
    padding: 35px 25px;
  }
  .el-form-item__label {
    width: 100% !important;
  }
  .el-form-item__content {
    width: 100% !important;
  }
  .generate-btn {
    width: 100%;
    justify-content: center;
    padding: 12px 0 !important;
  }
}

/* 深度选择器：适配ElementUI组件样式 */
:deep(.el-textarea__inner::placeholder) {
  color: var(--place-holder-color) !important;
  font-size: var(--font-size);
}

:deep(.el-message) {
  border-radius: var(--radius-sm);
  background-color: var(--bg-front);
  border: 1px solid var(--label-border);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

:deep(.el-message__content) {
  font-size: var(--font-size);
  color: var(--txt-color);
  transition: color 0.3s ease;
}

:deep(.el-message-success) {
  color: var(--green);
}

:deep(.el-message-error) {
  color: var(--red);
}

/* 隐藏 Webkit 内核浏览器（Chrome、Safari、Edge）的滚动条 */
.core-card::-webkit-scrollbar {
  display: none; /* 直接隐藏滚动条 */
}

/* 隐藏 Firefox 浏览器的滚动条 */
.core-card {
  scrollbar-width: none; /* Firefox 专属属性，隐藏滚动条 */
}

/* 隐藏 IE/旧版 Edge 浏览器的滚动条（兼容性补充） */
.core-card {
  -ms-overflow-style: none; /* IE/Edge 专属属性 */
}

.big_chat_box {
  width: 800px;
}

.small_chat_box {
  min-width: 620px;
  max-width: 620px;
}

/* ----------------------------------- 示例按钮的相关样式 ------------------------------------------- */
/* 容器：控制宽度500-800px，居中缩进，继承全局背景 */
.assistance-case-container {
  width: clamp(500px, 100%-20px, 780px);
  margin: 0 auto;
  padding: 10px;
  background-color: transparent; /* 继承父元素背景 */
}

/* 案例按钮样式：完全使用全局CSS变量，覆盖Element默认样式 */
.assistance-case-btn {
  width: 100% !important;
  margin: 5px 0 !important;
  text-align: left !important;
  line-height: var(--line-height-base) !important; /* 继承全局行高 */
  padding: 12px 23px !important; /* 与全局按钮padding一致 */
  border-radius: 20px !important; /* 与全局按钮圆角一致 */
  background-color: var(--btn-bg) !important; /* 全局按钮背景 */
  border: 1px solid var(--btn-border) !important; /* 全局按钮边框 */
  color: var(--btn-color) !important; /* 全局按钮文字色 */
  white-space: normal !important; /* 强制取消单行限制 */
  word-wrap: break-word !important; /* 基础换行 */
  transition: all 0.3s ease !important; /* 继承全局过渡动画 */
}

/* 按钮hover效果：使用全局hover变量 */
.assistance-case-btn:hover {
  background-color: var(--btn-bg-hover) !important; /* 全局按钮hover背景 */
  border-color: var(--btn-border-hover) !important; /* 全局按钮hover边框 */
  color: var(--btn-color-hover) !important; /* 全局按钮hover文字色 */
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1) !important; /* 弱阴影，不破坏全局风格 */
  transform: translateY(-1px) !important; /* 轻微上浮，增强交互 */
}

/* 内容容器：间距适配全局风格 */
.case-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px; /* 紧凑间距，符合全局UI风格 */
}

/* 单个条目：flex布局，标签+内容 */
.case-item {
  display: flex;
  flex-wrap: wrap; /* 标签和内容超出时换行 */
  width: 100%;
  align-items: flex-start; /* 顶部对齐，避免文本换行后错位 */
}

/* 标签样式：使用全局文字色2，加粗突出 */
.case-label {
  font-weight: 600;
  color: var(--txt-color2); /* 全局次要文字色 */
  min-width: 80px; /* 固定标签宽度，保证对齐 */
  flex-shrink: 0; /* 禁止标签收缩 */
  font-size: var(--font-size); /* 继承全局字体大小 */
}

/* 内容值样式：核心换行逻辑，使用全局主文字色 */
.case-value {
  color: var(--txt-color); /* 全局主文字色 */
  flex: 1; /* 占满剩余宽度 */
  word-break: break-all; /* 强制换行：连续字母/数字 */
  white-space: pre-wrap; /* 保留原文本换行符 */
  word-wrap: break-word; /* 中英文混合换行 */
  font-size: var(--font-size); /* 继承全局字体大小 */
  line-height: var(--line-height-base); /* 继承全局行高 */
}

/* 适配小屏幕：标签宽度自适应 */
@media (max-width: 600px) {
  .case-label {
    min-width: 60px;
  }
}
.my_workbench {
  overflow-y: auto;
  overflow-x: hidden;
  /* 适配 Firefox */
  scrollbar-width: none;
  /* 适配 IE/Edge 旧版 */
  -ms-overflow-style: none;
  /* 必须保留 overflow 保证滚动功能（根据需求选 auto/scroll/y/x） */
}
/* 适配 Chrome/Safari/Edge 新版（webkit 内核） */
.my_workbench::-webkit-scrollbar {
  display: none; /* 完全隐藏滚动条 */
}
.my_workbench::-webkit-scrollbar:vertical {
  display: none;
}
.my_workbench::-webkit-scrollbar:horizontal {
  display: none;
}
</style>
